import {ThemeProvider} from '@primer/react-brand'

import type {CategoryPage} from '../../../schemas/contentful/contentTypes/categoryTemplate'
import {ContentfulHero} from '../../../components/contentful/ContentfulHero/ContentfulHero'

export type CategoryTemplateProps = {
  page: CategoryPage
}

export function CategoryTemplate({page}: CategoryTemplateProps) {
  const {hero} = page.fields.template.fields

  return (
    <ThemeProvider
      colorMode={page.fields.settings?.fields.colorMode ?? 'light'}
      style={{backgroundColor: 'var(--brand-color-canvas-default)'}}
    >
      <ContentfulHero data-hpc component={hero} />
    </ThemeProvider>
  )
}

try{ CategoryTemplate.displayName ||= 'CategoryTemplate' } catch {}